import { AssetVariant } from '../domain/enums.js';
import { z } from '../zod.js';
import { Uuid } from './common.js';
/**
 * Images in the editor (1.R): uploads, Notion images re-hosted, and the files themselves
 * (baseline section 3 "ASSETS"; section 11's upload cap).
 */
/** The image types `assets.upload` accepts. */
export const IMAGE_MIME_TYPES = ['image/png', 'image/jpeg', 'image/gif', 'image/webp'];
export const ImageMimeType = z.enum(IMAGE_MIME_TYPES);
/** The image upload cap (baseline section 11: 25 MB), as 25 MiB. */
export const IMAGE_UPLOAD_MAX_BYTES = 26_214_400;
/** The form fields of `assets.upload` beside its `file`. */
export const AssetUploadFieldsV1 = z.strictObject({ docId: Uuid, blockId: Uuid });
/** A stored image and where the app serves it (`/files/<assetId>`). */
export const AssetRefV1 = z.strictObject({
    assetId: Uuid,
    sha256: z.string().regex(/^[0-9a-f]{64}$/),
    mime: z.string().regex(/^[a-z]+\/[a-z0-9.+-]+$/),
    bytes: z.number().int().nonnegative(),
    width: z.number().int().positive().nullable(),
    height: z.number().int().positive().nullable(),
    url: z.string().regex(/^\/files\/[0-9a-f-]{36}$/),
});
/** `assets.fetch`: re-host an image the GM pasted from elsewhere (a Notion export, a page). */
export const AssetFetchRequestV1 = z.strictObject({
    url: z
        .string()
        .max(8192)
        .regex(/^https?:\/\//),
    docId: Uuid,
    blockId: Uuid,
    notionBlockId: z.string().min(1).max(200).optional(),
});
/**
 * The image is stored now (`hosted`), or recorded as pending (`asset_pending`, an Inbox item)
 * with the reason it could not be fetched yet.
 */
export const RehostResultV1 = z.discriminatedUnion('status', [
    z.strictObject({ status: z.literal('hosted'), asset: AssetRefV1 }),
    z.strictObject({
        status: z.literal('pending'),
        pendingId: Uuid,
        reason: z.string().min(1).max(500),
    }),
]);
export const AssetFileParamsV1 = z.strictObject({ assetId: Uuid });
/** Without `variant`, the original file. */
export const AssetFileQueryV1 = z.strictObject({ variant: AssetVariant.optional() });
//# sourceMappingURL=assets.js.map